import ambiente from "./ambiente";

// Telas dormentes: com a flag ligada (REACT_APP_ESTAGIO === "dev" ou TELAS_DORMENTES "true" na
// configuração de execução do ambiente, beta) ficam no lugar normal do menu e da rota; com a flag
// desligada existem em todos os ambientes, mas só para o perfil "trimap", no menu "Em teste".
// Lido a cada chamada. window.__ENV__ (config.js) já existe quando o bundle carrega.
export function telaAtiva() {
  return (
    process.env.REACT_APP_ESTAGIO === "dev" ||
    (ambiente && ambiente.TELAS_DORMENTES === "true")
  );
}

// Perfis da rota de uma tela dormente.
export function perfisDaRota(perfisNormais, ativa = telaAtiva()) {
  return ativa ? perfisNormais : ["trimap"];
}

// Monta o menu: itens com `dormente: true` ficam no lugar com o `visible` normal (ativa) ou
// vão para o menu de primeiro nível "Em teste", só do trimap (flag desligada).
export function montarMenu(navegacao, ativa, possuiPerfil) {
  return montarMenus(navegacao, undefined, ativa, possuiPerfil).navigation;
}

// Variação que também trata o menu de Configurações: os itens dormentes dele saem de
// "Configurações" e entram em "Em teste" (depois dos do menu principal) com a flag desligada.
// Em "Em teste", um item com `categoria` entra no submenu dessa categoria (na ordem em que a
// categoria aparece primeiro); sem `categoria`, fica direto em "Em teste". Um grupo do menu que
// fica sem itens porque todos viraram dormentes some.
export function montarMenus(navegacao, configuracoes, ativa, possuiPerfil) {
  const emTeste = [];

  const paraEmTeste = (item) => {
    if (!item.categoria) {
      emTeste.push(item);
      return;
    }
    const { categoria, ...semCategoria } = item;
    let grupo = emTeste.find((i) => i.categoriaEmTeste === categoria);
    if (!grupo) {
      grupo = { text: categoria, categoriaEmTeste: categoria, items: [] };
      emTeste.push(grupo);
    }
    grupo.items.push(semCategoria);
  };

  const processar = (itens) =>
    itens.reduce((acc, item) => {
      if (item.dormente) {
        if (ativa) {
          const { categoria, ...noLugar } = item;
          acc.push({ ...noLugar, visible: possuiPerfil(item.perfis) });
        } else {
          const { dormente, perfis, ...resto } = item;
          paraEmTeste(resto);
        }
        return acc;
      }
      if (item.items) {
        const items = processar(item.items);
        if (item.items.length > 0 && items.length === 0) return acc;
        acc.push({ ...item, items });
        return acc;
      }
      acc.push(item);
      return acc;
    }, []);

  const menu = processar(navegacao);
  const config = configuracoes && { ...configuracoes, items: processar(configuracoes.items) };
  if (emTeste.length > 0) {
    menu.push({
      text: "Em teste",
      icon: "warning",
      visible: possuiPerfil(["trimap"]),
      items: emTeste.map(({ categoriaEmTeste, ...item }) => item),
    });
  }
  return { navigation: menu, configuracoes: config };
}
